
import EmptyApiResponse from '../../api/dtos/EmptyApiResponse';
import { AppDispatcher } from '../types';
import { HANDLE_ERROR, HANDLE_SUCCESS, HIDE_ALL_MESSAGES, PAGE_END_LOADING, PAGE_START_LOADING, PageActionTypes, RESET_ERROR, RESET_MESSAGE, SHOW_ERROR_MESSAGE, SHOW_INFO_MESSAGE } from './types';

export async function WrapNetworkCall<T>(dispatch: AppDispatcher, action: () => Promise<T>, withLoading: boolean = false): Promise<T> {
	if (withLoading) {
		dispatch(StartLoading());
	}

	try {
		return await action();
	}
	catch (errorCode) {
		dispatch(HandleError({
			is_success: false,
			error_code: 'HTTP_' + errorCode,
			error_message: 'Catch error ' + errorCode
		}));
		throw errorCode;
	}
	finally {
		if (withLoading) {
			dispatch(FinishedLoading());
		}
	}
}
export function HandleError(response: EmptyApiResponse): PageActionTypes {
	return {
		type: HANDLE_ERROR,
		response: response
	};
}

export function HandleSuccess(message: string, duration: number = 3000): PageActionTypes {
	return {
		type: HANDLE_SUCCESS,
		duration: duration,
		message: message
	}
}
export function ShowInfoMessage(message: string, duration: number = 3000): PageActionTypes {
	return {
		type: SHOW_INFO_MESSAGE,
		duration: duration,
		message: message
	}
}

export function ShowErrorMessage(message: string, duration: number = 3000): PageActionTypes {
	return {
		type: SHOW_ERROR_MESSAGE,
		duration: duration,
		message: message
	}
}

export function HideAllMessages(): PageActionTypes {
	return {
		type: HIDE_ALL_MESSAGES
	}
}
export function StartLoading(): PageActionTypes {
	return {
		type: PAGE_START_LOADING,
	}
}

export function FinishedLoading(): PageActionTypes {
	return {
		type: PAGE_END_LOADING,
	}
}
export function ResetError(): PageActionTypes {
	return {
		type: RESET_ERROR
	};
}

export function ResetMessage(): PageActionTypes {
	return {
		type: RESET_MESSAGE
	}
}